"use strict";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var React = require("react");
var config = require("./config");
var classNames = require("classnames");
var createClass = require("create-react-class");
var scriptLoader = require("load-script");

module.exports = function (scope) {
  return createClass({
    getInitialState: function getInitialState() {
      return {
        videosAvailable: 0,
        videos: []
      };
    },


    componentDidMount: function componentDidMount() {
      var t = this;

      if (window.DemoUpContainerRenderer) {
        return;
      } else {
        scriptLoader(config.containerPath(scope, this.props.mode), function () {
          if (window.DemoUpInfoFetcher) {
            window.DemoUpInfoFetcher(t.props, function (videos) {
              t.setState({ videosAvailable: videos.length });
              t.setState({ videos: videos });
            });
          }
        });
      }
    },

    componentWillUnmount: function componentWillUnmount() {
      document.dispatchEvent(new CustomEvent("demoup.unmounted"));
    },

    setRef: function setRef(node) {
      this.$container = node;
    },

    render: function render() {
      var _this = this;

      var props = this.props;
      var childrenWithProps = React.Children.map(this.props.children, function (child) {
        return React.cloneElement(child, {
          videosAvailable: _this.state.videosAvailable,
          videos: _this.state.videos,
          threed: props.threed
        });
      });

      return React.createElement(
        "div",
        _extends({}, props, {
          className: classNames("demoup-container", props.className),
          ref: this.setRef,
          src: config.stage3Path(scope)
        }),
        childrenWithProps
      );
    }
  });
};